import React from 'react';
import Navbar from './Navbar';

const BlogsPage = () => {
  return (
    <>
    <Navbar />
    <div>
      <h1>Blogs Page</h1>
      <p>Read our latest blogs and articles.</p>
    </div>
    </>
  );
};

export default BlogsPage;
